import { TextField } from '@client/new/components/basic';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type SearchBoxInputProps = {
  onChange: (value: string) => void;
  value: string;
  InputProps?: React.ComponentProps<typeof TextField>['InputProps'];
};
export function SearchBoxInput({
  onChange,
  value,
  InputProps,
}: SearchBoxInputProps) {
  return (
    <TextField
      sx={{
        '& .MuiInputBase-root': {
          padding: '0.6rem',
          border: 'none',
        },
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        endAdornment: <FontAwesomeIcon icon={faMagnifyingGlass} />,
        ...InputProps,
      }}
    />
  );
}
